import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import type { App } from 'vue'

export default {
  install(app: App) {
    app.config.globalProperties.$api = APIClient
    app.provide('api', APIClient)
  }
}
